import { BbScrollablePaneComponent } from './../../../bb-scrollable-pane/bb-scrollable-pane.component';
import { Subscription, ReplaySubject } from 'rxjs';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { InteractivityWidgetSelectionService } from '../../services/interactivity-widget-selection.service';
import { InteractivityWidgetService } from '../../services/interactivity-widget.service';
import { IWidgetSelection } from '../../interfaces/IWidgetSelection';
import { IWidgetProperty } from '../../interfaces/IWidgetProperty';
import { PillboxConfiguration } from 'app/components/shared/bb-pillbox/bb-pillbox.component';
import { Constants } from '../../classes/constants';

@Component({
	selector: 'property-bar',
	templateUrl: './property-bar.component.html',
	styleUrls: ['./property-bar.component.scss']
})

export class PropertyBarComponent implements OnInit, OnDestroy {
	@ViewChild('scrollablePane') scrollablePane: BbScrollablePaneComponent;
	readonly propsNotToRender: string[] = [
		'publication', 'ignoreTimelineShow', 'ignoreTimelineHide',
		'text', 'toppadding', 'bottompadding', 'cssclass', 'useAsKPI', 'showControls',
		'xpos', 'ypos', 'width', 'height',
		'clipid', 'imageid', 'imageid_mouseover', 'imageid_mousedown', 'imageid_toggle'
	];
	public eventHandlerNames: string[];

	// These are used in the template
	aspectRatio = 0;
	dropdownOpenObs: ReplaySubject<Event>;
	appsInSelection = false;
	componentsToRender: PillboxConfiguration[];

	private widgetSelection: IWidgetSelection;
	private keyOrder: string[];
	private subscriptions = new Subscription();

	constructor(
		private widgetSelectionService: InteractivityWidgetSelectionService,
		private interactivityWidgetService: InteractivityWidgetService
	) {

		this.eventHandlerNames = Constants.eventHandlerNames;
		this.widgetSelection = { widgets: [], commonProperties: [] };
		this.keyOrder = ['xpos', 'ypos', 'width', 'height',
			'textFormat/textFormat/font',
			'textFormat/textFormat/fontsize', 'textFormat/textFormat/color', 'textFormat/textFormat/bold',
			'textFormat/textFormat/italic', 'textFormat/textFormat/underline', 'textFormat/textFormat/align',
			'background', 'backgroundcolor', 'color', 'background_alpha', 'textFormat/textFormat/background_alpha', 'imageid', 'alpha',
			'bordercolor', 'borderthickness', 'cornerradius', 'imageid_mouseover',
			'imageid_mousedown', 'imageid_toggle',
			'textFormat/textFormat/margin', 'padding', 'useAsKPI', 'cssclass', 'showControls', 'appid'];
		this.componentsToRender = [];
		this.dropdownOpenObs = new ReplaySubject(1);
	}

	ngOnInit() {
		this.subscriptions.add(this.widgetSelectionService.widgetSelectionSubject.subscribe((data: IWidgetSelection) => {
			this.widgetSelection = data;

			// check if the selected widgets includes apps
			this.appsInSelection = this.widgetSelection.widgets.some(widget => widget && widget.type === 'app');

			// let newWidgetIds = data.widgets.map((widget: StageWidget) => widget.id);

			this.componentsToRender = [];
			for (let i = 0, l = this.widgetSelection.commonProperties.length; i < l; i++) {
				const prop: IWidgetProperty = this.widgetSelection.commonProperties[i];
				if (this.propsNotToRender.indexOf(prop.key) === -1 && this.eventHandlerNames.indexOf(prop.key) === -1) {
					this.componentsToRender.push(this.interactivityWidgetService.getComponentConfigFromProperty(prop));
				}
			}

			this.mapOrder(this.componentsToRender, this.keyOrder, 'key');
			setTimeout(() => {
				this.aspectRatio = this.interactivityWidgetService.aspectRatio;
				this.scrollablePane.update();
			});
		}));

	}

	trackBy(ind: number, item: any) {
		return item.key || ind;
	}

	toggleAspectRatioLocked(idx: number) {
		this.componentsToRender[idx].aspectRatioLocked = this.interactivityWidgetService.aspectRatioLocked = !this.interactivityWidgetService.aspectRatioLocked;
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	changeProperty(changedProp: any, mayKeepAspectRatio: boolean = true): void {
		this.interactivityWidgetService.changeProperty(changedProp, mayKeepAspectRatio);
	}

	onDropdownOpened(ev: Event) {
		this.dropdownOpenObs.next(ev); // observable to pass data async and avoid ExpressionChangedAfterItHasBeenCheckedError
	}

	private mapOrder(array: PillboxConfiguration[], order: string[], key: string) {
		array.sort((a: any, b: any) => {
			let A = a[key]; let B = b[key];
			// strip delimiters etc.
			const A_parts: string[] = (A) ? A.split(';') : [];
			if (A_parts.length > 0) {
				A = A_parts[0];
			}
			const B_parts: string[] = (B) ? B.split(';') : [];
			if (B_parts.length > 0) {
				B = B_parts[0];
			}
			return (order.indexOf(A) > order.indexOf(B)) ? 1 : -1;
		});
		return array;
	}

}
